import React from 'react';
import { ChatSidePanelEmptyText } from './ChatSidePanelCard';
import { SkeletonLine, SkeletonPill } from '../../Skeleton';

const defaultResolveRowKey = (row, index) => row?.id || `summary-row-${index}`;

export default function ChatSidePanelSummaryList({
  rows = [],
  isLoading = false,
  loadingLabel = '読み込み中...',
  emptyText = '',
  renderRow,
  resolveRowKey = defaultResolveRowKey,
  listClassName = 'side-list',
}) {
  const safeRows = Array.isArray(rows) ? rows : [];

  if (isLoading) {
    return (
      <ul className={listClassName} role="status" aria-live="polite" aria-label={loadingLabel}>
        {Array.from({ length: 3 }, (_, index) => (
          <li key={`chat-summary-skeleton-${index}`} aria-hidden="true">
            <div className="side-list-row">
              <SkeletonLine width={index === 1 ? '72%' : '86%'} height={13} />
              <SkeletonLine width={index === 2 ? '48%' : '62%'} height={10} />
              <SkeletonPill width={index === 0 ? 68 : 92} height={18} />
            </div>
          </li>
        ))}
      </ul>
    );
  }

  if (safeRows.length === 0) {
    return <ChatSidePanelEmptyText>{emptyText}</ChatSidePanelEmptyText>;
  }

  return (
    <ul className={listClassName}>
      {safeRows.map((row, index) => (
        <li key={resolveRowKey(row, index)}>
          {renderRow?.(row, index)}
        </li>
      ))}
    </ul>
  );
}
